<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">入库记录</h3>
            <div class="box-tools pull-right">
              <handle @finish="finish">入库操作</handle>
            </div>
          </div>
          <div class="box-body no-padding">
            <div style="padding-top: 20px;padding-left: 20px;">
              <el-form :inline="true">
                <el-form-item label="日期">
                  <el-date-picker
                      v-model="query.day"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="querySelect">查询</el-button>
                </el-form-item>
              </el-form>
            </div>

            <el-table :data="list" border v-loading="listLoading" style="width: 100%">
              <el-table-column prop="create_time" label="入库时间" width="220"></el-table-column>
              <el-table-column label="入库成功信息">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <in-detail :info="scope.row.success" title="入库成功信息">
                      {{ scope.row.success.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="MCU已经绑定">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <in-detail :info="scope.row.fault_mcu_bind" title="MCU已经绑定">
                      {{ scope.row.fault_mcu_bind.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="条码已绑定">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <in-detail :info="scope.row.fault_bar_code_bind" title="条码已绑定">
                      {{ scope.row.fault_bar_code_bind.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="条码不存在错误">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <in-detail :info="scope.row.fault_bar_code_notfound" title="条码不存在错误">
                      {{ scope.row.fault_bar_code_notfound.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="MCU已在库存">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <in-detail :info="scope.row.fault_inventory_mcu_had" title="MCU已在库存">
                      {{ scope.row.fault_inventory_mcu_had.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="条码已在库存">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <in-detail :info="scope.row.fault_inventory_bar_code_had" title="条码已在库存">
                      {{ scope.row.fault_inventory_bar_code_had.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="padding: 10px">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                  :page-size="query.size"
                  :current-page="query.page"
                  @current-change="pageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import qs from "qs";

import InDetail from "./InDetail.vue";
import Handle from "./Handle.vue";

export default {
  components: {InDetail, Handle},
  data() {
    return {
      params: {},
      query: {
        day: '',
        page: 1,
        size: 10,
      },
      list: [],
      total: 0,
      listLoading: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.listLoading = true;
    _this.authInit(_this).then(() => {
      _this.loadList();
    });
  },
  methods: {
    ...mapActions(["authInit"]),
    updateUrl() {
      const _this = this;
      const url = _this.$route.path + "?" + qs.stringify(_this.query);
      _this.$router.replace({path: url});
    },
    // 获取列表
    loadList() {
      const _this = this;
      _this.$api.wareInList(_this.query)
          .then(res => {
            _this.listLoading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.updateUrl();
          })
          .catch(err => {
            _this.listLoading = false;
            _this.$message.error(err.msg);
          })
    },
    // 分页
    pageChange(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.listLoading = true;
      _this.loadList();
    },
    // 筛选
    querySelect() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
    finish() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>